var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgSales = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24.412,
      height: 24.414,
      viewBox: "0 0 24.412 24.414",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22123",
      "data-name": "Path 22123",
      d: "M5844.207,1207.241a12.207,12.207,0,1,0,12.207,12.207A12.206,12.206,0,0,0,5844.207,1207.241Zm4.311,17.578a5.565,5.565,0,0,1-2.978,1.217v1.047a.66.66,0,0,1-.691.691h-1.128a.7.7,0,0,1-.482-.186.668.668,0,0,1-.208-.5v-1.046a5.965,5.965,0,0,1-2.114-.641,4.1,4.1,0,0,1-1.511-1.331,3.339,3.339,0,0,1-.56-1.7v-.011a.619.619,0,0,1,.193-.444.64.64,0,0,1,.461-.193h1.638a.824.824,0,0,1,.481.127,1.082,1.082,0,0,1,.3.342l.015.025.009.028a1.69,1.69,0,0,0,.743.9,3.01,3.01,0,0,0,1.636.378,3.242,3.242,0,0,0,1.761-.385,1.088,1.088,0,0,0,.532-.961.858.858,0,0,0-.253-.639,2.515,2.515,0,0,0-.9-.515c-.433-.16-1.083-.357-1.934-.584a8,8,0,0,1-3.246-1.4,3.209,3.209,0,0,1-1.092-2.6,3.454,3.454,0,0,1,1.106-2.586,4.935,4.935,0,0,1,2.733-1.239v-1.034a.669.669,0,0,1,.208-.5.694.694,0,0,1,.482-.186h1.128a.661.661,0,0,1,.691.691v1.074a5.181,5.181,0,0,1,1.911.7,4.317,4.317,0,0,1,1.371,1.326,3.169,3.169,0,0,1,.521,1.5v.014a.627.627,0,0,1-.636.636h-1.729a.786.786,0,0,1-.76-.479l-.012-.027-.005-.029a1.226,1.226,0,0,0-.606-.806,2.525,2.525,0,0,0-1.382-.351,2.581,2.581,0,0,0-1.433.339,1,1,0,0,0-.46.9.957.957,0,0,0,.22.653,2.126,2.126,0,0,0,.813.513,13.926,13.926,0,0,0,1.758.535,12.857,12.857,0,0,1,2.622.836h0a3.626,3.626,0,0,1,1.513,1.236,3.416,3.416,0,0,1,.5,1.9A3.487,3.487,0,0,1,5848.517,1224.819Z",
      transform: "translate(-5832 -1207.24)"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgSales, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Sales.0c1fc6e8.svg";
export { ForwardRef as ReactComponent };